import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
// Import RxJs required methods

@Injectable()
export class ControlCrane {
  private kranSteuerungURL = "LiftplanII/Kransteuerung/kranSteuerung.php";
  constructor(private http: HttpClient) {}
  getGrafik(kranDatenbankNamen: string): Promise<string> {
    const theURL = this.kranSteuerungURL + "?action=erzeugeWinkelAnsicht";
    return this.http.get<string>(theURL).toPromise().catch(this.handleError);
  }

  erzeugeKran(
    kranDatenbankNamen: string,
    kranPointer: string,
    seitenSpiegeln: boolean,
    mitMAXan = true
  ): Promise<Response> {
    const theURL: string[] = [
      this.kranSteuerungURL + "?action=erzeugeKran",
      "kranDatenbankNamen=" + kranDatenbankNamen,
      "kranPointer=" + kranPointer,
      "seitenSpiegeln=" + seitenSpiegeln,
      "mitMAXan=" + mitMAXan,
    ];
    return this.http
      .get<Response>(theURL.join("&"))
      .toPromise()
      .catch(this.handleError);
  }
  minMAXan(mitMAXan = true): Promise<Response> {
    return this.http
      .get<Response>(
        this.kranSteuerungURL + "?action=mitMAXanSetzen&mitMAXan=" + mitMAXan
      )
      .toPromise()
      .catch(this.handleError);
  }
  holeRuestdaten(): Promise<Response> {
    const theUrl: string =
      this.kranSteuerungURL + "?action=holeAktuelleRuestdaten";
    return this.http.get<Response>(theUrl).toPromise().catch(this.handleError);
  }
  holeErgebnisse(): Promise<Response> {
    const theUrl: string = this.kranSteuerungURL + "?action=holeErgebnisse";
    return this.http.get<Response>(theUrl).toPromise().catch(this.handleError);
  }
  holeLastTabellen(): Promise<Response> {
    const theUrl: string = this.kranSteuerungURL + "?action=holeLastTabellen";
    return this.http.get<Response>(theUrl).toPromise().catch(this.handleError);
  }
  holeRLHTabelle(): Promise<Response> {
    const theUrl: string = this.kranSteuerungURL + "?action=holeRLHTabelle";
    return this.http.get<Response>(theUrl).toPromise().catch(this.handleError);
  }
  holeMAXWerte(): Promise<Response> {
    const theUrl: string = this.kranSteuerungURL + "?action=holeMAXWerte";
    return this.http.get<Response>(theUrl).toPromise().catch(this.handleError);
  }
  aendereHALaenge(haWerte: Object): Promise<Response> {
    const theUrl: string[] = [
      this.kranSteuerungURL + "?action=setzeHALaenge",
      "haLaenge=" + haWerte["HALaenge"],
      "haAusfahrf=" + haWerte["HAausfahrf"],
    ];
    return this.http
      .get<Response>(theUrl.join("&"))
      .toPromise()
      .catch(this.handleError);
  }
  aendereGegengewicht(gegengewicht: string): Promise<Response> {
    const theUrl: string[] = [
      this.kranSteuerungURL + "?action=setzeGegengewicht",
      "gegengewicht=" + gegengewicht,
    ];
    return this.http
      .get<Response>(theUrl.join("&"))
      .toPromise()
      .catch(this.handleError);
  }
  aendereHAWinkel(haWinkel: string): Promise<Response> {
    const theUrl: string[] = [
      this.kranSteuerungURL + "?action=setzeHAWinkel",
      "haWinkel=" + haWinkel,
    ];
    return this.http
      .get<Response>(theUrl.join("&"))
      .toPromise()
      .catch(this.handleError);
  }

  aendereHi1Winkel(hi1Winkel: string): Promise<Response> {
    const theUrl: string[] = [
      this.kranSteuerungURL + "?action=setzeHi1Winkel",
      "hi1Winkel=" + hi1Winkel,
    ];
    return this.http
      .get<Response>(theUrl.join("&"))
      .toPromise()
      .catch(this.handleError);
  }
  aendereRadius(radius: string): Promise<Response> {
    const theUrl: string[] = [
      this.kranSteuerungURL + "?action=setzeRadius",
      "radius=" + radius,
    ];
    return this.http
      .get<Response>(theUrl.join("&"))
      .toPromise()
      .catch(this.handleError);
  }
  aendereOWWinkel(owWinkel: string): Promise<Response> {
    const theUrl: string[] = [
      this.kranSteuerungURL + "?action=setzeOWWinkel",
      "owWinkel=" + owWinkel,
    ];
    return this.http
      .get<Response>(theUrl.join("&"))
      .toPromise()
      .catch(this.handleError);
  }
  aendereLast(last: string): Promise<Response> {
    const theUrl: string[] = [
      this.kranSteuerungURL + "?action=setzeLast",
      "last=" + last,
    ];
    return this.http
      .get<Response>(theUrl.join("&"))
      .toPromise()
      .catch(this.handleError);
  }
  erzeugeNeueFilterListe(
    werteObjekt: any,
    rueckgabeWerte: string[]
  ): Promise<Response> {
    const theUrl: string[] = [
      this.kranSteuerungURL + "?action=erzeugeNeueFilterListe",
    ];
    for (const wert in werteObjekt) {
      if (werteObjekt.hasOwnProperty(wert)) {
        theUrl.push(wert + "=" + werteObjekt[wert]);
      }
    }
    if (rueckgabeWerte.length > 0) {
      theUrl.push("rueckgabeWerte=" + rueckgabeWerte.join());
    }
    return this.http
      .get<Response>(theUrl.join("&"))
      .toPromise()
      .catch(this.handleError);
  }
  holeAktivenBereich(winkel: string): Promise<number> {
    const theUrl =
      this.kranSteuerungURL + "?action=holeAktivenBereich&OWWinkel=" + winkel;
    return this.http.get<number>(theUrl).toPromise().catch(this.handleError);
  }
  pruefeAufKompatiblenKran(): Promise<Response> {
    const theURL = this.kranSteuerungURL + "?action=sucheKompatiblenKran";
    return this.http.get<Response>(theURL).toPromise().catch(this.handleError);
  }
  handleError(error: Response | any) {
    console.log(error);
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || "";
      const err = JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return Observable.throw(errMsg).toPromise();
  }
}
